import { render, staticRenderFns } from "./CMChips.vue?vue&type=template&id=13d1146e&scoped=true&lang=pug&"
import script from "./CMChips.vue?vue&type=script&lang=js&"
export * from "./CMChips.vue?vue&type=script&lang=js&"
import style0 from "./CMChips.vue?vue&type=style&index=0&id=13d1146e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1146e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
